(() => {
  'use strict';
  const key = 'D6Ph42DV41RwaeBriZMzfE0SYDZMeUyCjxH3Zc27';
  const element = (tag, text, cls) => {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (cls) node.className = cls;
    return node;
  };
  async function refresh(section) {
    if (section.dataset.loading === 'true') return;
    section.dataset.loading = 'true';
    try {
      let rows = [], expected, bottomline;
      const ids = new Set();
      for (let page = 1; page <= 200; page++) {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 15000);
        let payload;
        try {
          const response = await fetch(`https://api-cdn.yotpo.com/v1/widget/${key}/products/${encodeURIComponent(section.dataset.yotpoProduct)}/reviews.json?per_page=50&page=${page}`, {signal: controller.signal});
          if (!response.ok) throw new Error('Review source unavailable');
          payload = await response.json();
        } finally { clearTimeout(timer); }
        if (payload.status?.code !== 200) throw new Error('Invalid review response');
        const data = payload.response;
        if (!Array.isArray(data?.reviews) || !Number.isInteger(data.pagination?.total)) throw new Error('Invalid review data');
        if (expected !== undefined && expected !== data.pagination.total) throw new Error('Review count changed during fetch');
        expected = data.pagination.total;
        bottomline = bottomline || data.bottomline;
        for (const review of data.reviews) {
          if (ids.has(review.id) || !Number.isInteger(review.score) || review.score < 1 || review.score > 5) throw new Error('Invalid or duplicate review');
          ids.add(review.id); rows.push(review);
        }
        if (rows.length >= expected || !data.reviews.length) break;
      }
      if (rows.length !== expected || !Number.isFinite(bottomline?.average_score)) throw new Error('Incomplete review data');
      const fragment = document.createDocumentFragment();
      fragment.append(element('h2', section.dataset.yotpoProduct === 'yotpo_site_reviews' ? 'Yotpo Store Reviews' : 'Customer Reviews', 'yotpo-seo-reviews__title'));
      const summary = element('p', undefined, 'yotpo-seo-reviews__summary');
      summary.append(element('strong', String(Math.round(bottomline.average_score * 100) / 100)), document.createTextNode(` out of 5 · ${rows.length} published Yotpo reviews`));
      fragment.append(summary);
      const time = element('time', new Date().toLocaleString());
      time.dateTime = new Date().toISOString();
      const status = element('p', 'Live Yotpo data checked: ', 'yotpo-seo-review__meta');
      status.append(time); fragment.append(status);
      rows.sort((a,b) => Date.parse(b.created_at) - Date.parse(a.created_at));
      for (const review of rows) {
        const article = element('article', undefined, 'yotpo-seo-review');
        if (review.title) article.append(element('h3', review.title, 'yotpo-seo-review__title'));
        const meta = element('p', `${review.score} out of 5 stars · ${review.user?.display_name || 'Customer'}${review.verified_buyer ? ' (verified buyer)' : ''} · ${review.created_at.slice(0,10)}`, 'yotpo-seo-review__meta');
        article.append(meta, element('p', review.content, 'yotpo-seo-review__body'));
        if (review.is_incentivized) article.append(element('p', 'Incentivized review', 'yotpo-seo-review__meta'));
        if (review.comment?.content) article.append(element('p', `Reply from DidaPop: ${review.comment.content}`, 'yotpo-seo-review__body'));
        fragment.append(article);
      }
      section.replaceChildren(fragment);
      section.dataset.liveStatus = 'success';
    } catch (error) {
      section.dataset.liveStatus = 'fallback';
      // Retain last successful server-rendered content; never replace with guessed data.
    } finally { delete section.dataset.loading; }
  }
  const start = () => {
    const sections = [...document.querySelectorAll('[data-yotpo-product]')];
    sections.forEach(refresh);
    setInterval(() => { if (!document.hidden) sections.forEach(refresh); }, 300000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();

